module.exports = __webpack_public_path__ + "static/media/featured-1-bed-tc.a745b872.png";